// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__173i8","tabsBox":"styles_tabsBox__19e6D","createButton":"styles_createButton__qDlRG"};